import React, { useEffect, useRef, useState } from "react"
import * as Yup from "yup"
import { Col, Row, CardTitle, Label, Input, Button, Form } from "reactstrap"

import ArrowDown from "../../assets/images/icons/ArrowDown.svg"
import editIcon from "../../assets/images/icons/edit.svg"
import { addSpaceEveryNChars, checkExtension } from "helpers/common"
import { Link, useNavigate } from "react-router-dom"
import pdfIcon from "../../assets/images/icons/file-type.svg"
import imageIcon from "../../assets/images/icons/image.svg"
import {
  useKycFinalSubmissionMutation,
  useUpdateKycStepMutation,
} from "store/api/kyc/kyc"
import { useDispatch, useSelector } from "react-redux"
import { setLoginUserData } from "store/slices/userSlice"
import toast from "react-hot-toast"
import Spinners from "components/Common/Spinner"
import { useFormik } from "formik"

const KycFinalStep = ({ kycData }) => {
  const [kycFinalSubmission, { isLoading }] = useKycFinalSubmissionMutation()
  const { user } = useSelector((state) => state.user)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [updateStep, { isLoading: isUpdatting }] = useUpdateKycStepMutation()

  const goToStep = async (step) => {
    try {
      await updateStep({ kyc_status: step }).unwrap()
      window.location.reload()
    } catch (error) { }
  }

  const submitForVerification = async () => {
    try {
      const { message, success } = await kycFinalSubmission({
        kycStep: kycData.status,
      }).unwrap()
      if (success) {
        toast.success(message, { id: "toastMessage" })

        dispatch(
          setLoginUserData({
            user: { ...user, kyc_status: "SUBMITTED" },
          })
        )
        navigate("/")
      }
    } catch (error) {
      toast.error(error?.data?.message, { id: "toastMessage" })
    }
  }

  return (
    <React.Fragment>
      <div
        style={{
          marginTop: "6rem",
          paddingInline: "2rem",
        }}
      >
        <Row>
          <Col xl={12}>
            <div>
              <div>
                <div className="d-flex align-items-center mt-4 mb-4 justify-content-between">
                  <CardTitle className="">Personal Details</CardTitle>
                </div>
                <Row className="mb-2">
                  <Col xl={6}>
                    <Label className="col-form-label">Name</Label>
                    <Input
                      disabled
                      name="name"
                      type="text"
                      className="form-control"
                      value={kycData?.investorsAadhaar?.name}
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">Date of Birth</Label>
                    <Input
                      disabled
                      name="name"
                      type="text"
                      className="form-control"
                      value={kycData?.investorsAadhaar?.dob}
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">PAN</Label>
                    <Input
                      disabled
                      name="name"
                      type="text"
                      className="form-control"
                      value={kycData?.investorsPAN?.pan}
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">Aadhaar No.</Label>
                    <Input
                      disabled
                      name="name"
                      type="text"
                      className="form-control"
                      value={addSpaceEveryNChars(
                        kycData?.investorsAadhaar?.aadhaar_no
                      )}
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">Phone No.</Label>
                    <Input
                      disabled
                      name="phone"
                      type="text"
                      className="form-control"
                      value={kycData?.phone}
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">Email Address</Label>
                    <Input
                      disabled
                      name="email"
                      type="text"
                      className="form-control"
                      value={kycData?.email}
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">Primary Address</Label>
                    <Input
                      disabled
                      name="email"
                      type="textarea"
                      className="form-control"
                      value={kycData?.additionalDetails?.primary_address}
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">Secondary Address</Label>
                    <Input
                      disabled
                      name="email"
                      type="textarea"
                      className="form-control"
                      value={kycData?.additionalDetails?.secondary_address}
                    />
                  </Col>
                  {/* {kycData?.additionalDetails?.business_trade_name && ( */}
                  <>
                    <Col xl={6}>
                      <Label className="col-form-label">
                        Trade Name of the Business
                      </Label>

                      <Input
                        disabled
                        name="phone"
                        type="text"
                        className="form-control"
                        value={
                          kycData?.additionalDetails?.business_trade_name ||
                          "Not Applicable"
                        }
                      />
                    </Col>
                    <Col xl={6}>
                      <Label className="col-form-label">GSTIN</Label>

                      <Input
                        disabled
                        name="phone"
                        type="text"
                        className="form-control"
                        value={
                          kycData?.additionalDetails?.gstin || "Not Applicable"
                        }
                      />
                    </Col>
                  </>
                  {/* )} */}
                </Row>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col xl={12}>
            <div>
              <div>
                <div className="d-flex align-items-center mb-4 mt-4 justify-content-between">
                  <CardTitle className="">Bank Details</CardTitle>
                </div>
                <Row className="mb-2">
                  <Col xl={6}>
                    <Label className="col-form-label">
                      Account Holders Name
                    </Label>
                    <Input
                      disabled
                      name="account_holder"
                      type="text"
                      className="form-control"
                      value={
                        kycData?.investorsBankDetails?.account_holder || ""
                      }
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">Account Number</Label>

                    <Input
                      disabled
                      name="account_no"
                      type="text"
                      className="form-control"
                      value={kycData?.investorsBankDetails?.account_no || ""}
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">Bank Name</Label>
                    <Input
                      disabled
                      name="bank_name"
                      type="text"
                      className="form-control"
                      value={kycData?.investorsBankDetails?.bank_name || ""}
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">IFSC</Label>
                    <Input
                      disabled
                      name="ifsc"
                      type="text"
                      className="form-control"
                      value={kycData?.investorsBankDetails?.ifsc || ""}
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">Account Type</Label>
                    <Input
                      disabled
                      name="account_type"
                      type="text"
                      className="form-control"
                      value={kycData?.investorsBankDetails?.account_type}
                    />
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
        </Row>

        <Row>
          <Col xl={12}>
            <CardTitle className="mt-4 mb-4">Documents</CardTitle>

            <CardTitle className="mt-4 mb-4" style={{ fontSize: "14px" }}>
              KYC Documents
            </CardTitle>
            <div className="documents-section">
              {kycData?.investorsAadhaar?.aadhaar_file && (
                <div className="documents-box">
                  <div className="file-type">
                    {checkExtension(
                      kycData?.investorsAadhaar.aadhaar_file_url
                    ) === "pdf" ? (
                      <img src={pdfIcon} alt="" />
                    ) : (
                      <img src={imageIcon} alt="" />
                    )}

                    <div>
                      <p>Aadhaar</p>
                      <Link
                        to={kycData?.investorsAadhaar.aadhaar_file_url}
                        target="_blank"
                      >
                        <span className="text-small text-success cursor-pointer">
                          View
                        </span>
                      </Link>
                    </div>
                    <p></p>
                  </div>
                  {/* <div className="verified-user">
                      <img src={check} alt="" /> Verified
                    </div> */}
                </div>
              )}
              {kycData?.avatar_url && (
                <div className="documents-box">
                  <div className="file-type">
                    {checkExtension(kycData?.avatar_url) === "pdf" ? (
                      <img src={pdfIcon} alt="" />
                    ) : (
                      <img src={imageIcon} alt="" />
                    )}

                    <div>
                      <p>Selfie</p>
                      <Link to={kycData?.avatar_url} target="_blank">
                        <span className="text-small text-success cursor-pointer">
                          View
                        </span>
                      </Link>
                    </div>
                    <p></p>
                  </div>
                  {/* <div className="verified-user">
                      <img src={check} alt="" /> Verified
                    </div> */}
                </div>
              )}
              {kycData?.investorsPAN?.pan_file && (
                <div className="documents-box">
                  <div className="file-type">
                    {checkExtension(kycData?.investorsPAN?.pan_file_url) ===
                      "pdf" ? (
                      <img src={pdfIcon} alt="" />
                    ) : (
                      <img src={imageIcon} alt="" />
                    )}

                    <div>
                      <p>PAN</p>
                      <Link
                        to={kycData?.investorsPAN?.pan_file_url}
                        target="_blank"
                      >
                        <span className="text-small text-success cursor-pointer">
                          View
                        </span>
                      </Link>
                    </div>
                    <p></p>
                  </div>
                  {/* <div className="verified-user">
                      <img src={check} alt="" /> Verified
                    </div> */}
                </div>
              )}
              {kycData?.avatar_url && (
                <div className="documents-box">
                  <div className="file-type">
                    {checkExtension(kycData?.avatar_url) === "pdf" ? (
                      <img src={pdfIcon} alt="" />
                    ) : (
                      <img src={imageIcon} alt="" />
                    )}

                    <div>
                      <p>Selfie</p>
                      <Link to={kycData?.avatar_url} target="_blank">
                        <span className="text-small text-success cursor-pointer">
                          View
                        </span>
                      </Link>
                    </div>
                    <p></p>
                  </div>
                  {/* <div className="verified-user">
                      <img src={check} alt="" /> Verified
                    </div> */}
                </div>
              )}
              {kycData?.additionalDetails?.gst_certificate && (
                <div className="documents-box">
                  <div className="file-type">
                    {checkExtension(
                      kycData?.additionalDetails?.gst_certificate_url
                    ) === "pdf" ? (
                      <img src={pdfIcon} alt="" />
                    ) : (
                      <img src={imageIcon} alt="" />
                    )}

                    <div>
                      <p>GST Certificate</p>
                      <Link
                        to={kycData?.additionalDetails?.gst_certificate_url}
                        target="_blank"
                      >
                        <span className="text-small text-success cursor-pointer">
                          View
                        </span>
                      </Link>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <CardTitle className="mt-4 mb-4" style={{ fontSize: "14px" }}>
              Banking Documents
            </CardTitle>
            <div className="documents-section">
              {kycData?.investorsBankDetails?.cheque_file && (
                <div className="documents-box">
                  <div className="file-type">
                    {checkExtension(
                      kycData?.investorsBankDetails.cheque_file_url
                    ) === "pdf" ? (
                      <img src={pdfIcon} alt="" />
                    ) : (
                      <img src={imageIcon} alt="" />
                    )}

                    <div>
                      <p>Cheque</p>
                      <Link
                        to={kycData?.investorsBankDetails.cheque_file_url}
                        target="_blank"
                      >
                        <span className="text-small text-success cursor-pointer">
                          View
                        </span>
                      </Link>
                    </div>
                    <p></p>
                  </div>
                  {/* <div className="verified-user">
                      <img src={check} alt="" /> Verified
                    </div> */}
                </div>
              )}
            </div>
            <div className="buttons">
              {/* <button
                  type="button"
                  onClick={() => goToStep("PHOTO")}
                  disabled={isLoading || isUpdatting}
                  className="btn btn-primary prev-button"
                >
                  {isUpdatting ? <Spinner size={"sm"} /> : "Previous Page"}
                </button> */}
              <Button
                type="button"
                className="btn btn-primary w-md"
                onClick={() => submitForVerification()}
                disabled={isLoading}
              >
                {isLoading ? <Spinners /> : "Submit for Verification"}
              </Button>
            </div>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  )
}

export default KycFinalStep
